/* globals angular, _ */
(function() {
  'use strict';

  function ReverseDetailsCtrl (
    mdPanelRef,
    $controller,
    moment,
    data,
    Historico,
    localStorageService
  ) {

    angular.extend(this, $controller('BasePanelCtrl', {}));

    var ctrl = this;

    ctrl.config = {
      title: 'Previsão de entrega',
      link: {
        url: _.get(data.rastreamento, 'url'),
        name: 'Ver rastreamento'
      },
      track: {
        status: 'Aguardando entrega',
        name: '',
        date: null,
        tries: []
      },
      loading: {
        panel: true
      },
      msgError: '',
      overdueDays: data.entrega.situacao.diasAtrasados,
    };

    function _fetchDetails () {
      ctrl.config.msgError = false;

      Historico
        .getEventsPackage(data.id)
        .then(function(details) {
          ctrl.enableDisableLoading(ctrl.config.loading, 'panel', null);

          ctrl.config.track.tries = details.mensagens;
          ctrl.config.track.name = details.situacao.nome;
          ctrl.config.track.status = details.situacao.informacao;
          ctrl.config.track.finished = details.situacao.statusFinal;
          ctrl.config.track.date = details.situacao.dataHora;
        })
        .catch(function() {
          ctrl.enableDisableLoading(ctrl.config.loading, 'panel', null);
          ctrl.config.msgError = true;
        });
    }

    _fetchDetails();

    function _displayDateHour (date, hideHours) {
      var formatDate = '';
      if (date) {
        formatDate = moment(date).format('ddd, DD MMM');
        if (+moment(date).format('s') > 0 && !hideHours) {
          formatDate += moment(date).format(' - H:mm');
        }
      }
      return formatDate;
    }

    ctrl.displayDateHour = function (date) {
      return _displayDateHour(date);
    };

    ctrl.formatDateMessage = function (name, date) {
      var hifen = _.isString(name) && _.isNumber(date) ? ' - ' : '';
      var hideHours = name && name.toLowerCase() === 'entrega prevista';
      var formatDate = _displayDateHour(date, hideHours);
      return ((name || '') + hifen + (formatDate || ''));
    };

    // Evaluated by ng-class on every digest; situacao.informacao can be null.
    ctrl.isDelivered = function () {
      var status = ctrl.config.track.status;
      return _.isString(status) && status.toLowerCase() === 'entregue';
    };

    ctrl.closePanel = function () {
      ctrl.close(mdPanelRef);
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReverseDetailsCtrl', ReverseDetailsCtrl);
}());
